import type { CSSProperties } from 'react'
import { Box, Card, Text } from '@grovus/design-system'
import type { Dict } from '../i18n'
import { HELP_ENTRIES } from './helpEntries'
import { PanelHeading } from './PanelHeading'
import type { PanelProps } from './useDisclosurePanel'

interface Props {
  t: Dict
  panelProps: PanelProps
}

/**
 * The help panel (GRO-66): every explanation the creatives table carries, in one place, each
 * as its question and then its answer. It holds no control, so the panel itself takes focus
 * on open (`tabIndex={-1}` from `panelProps`) and a screen reader reads it from there.
 */
export function HelpPanel({ t, panelProps }: Props) {
  return (
    <Card
      role="group"
      aria-label={t.helpLabel}
      className="header-panel"
      style={{ right: 0, '--panel-width': '360px' } as CSSProperties}
      {...panelProps}
    >
      <PanelHeading>{t.howToRead}</PanelHeading>
      <Box component="ul" m={0} p={0} style={{ listStyle: 'none' }}>
        {HELP_ENTRIES.map((entry) => (
          <Box component="li" key={entry.text} py="xs" style={{ borderTop: '1px solid var(--mantine-color-default-border)' }}>
            <Text fw={600} fz="sm">{t[entry.name]}</Text>
            <Text fz="xs" className="grv-muted" style={{ lineHeight: 1.5 }}>{t[entry.text]}</Text>
          </Box>
        ))}
      </Box>
    </Card>
  )
}
